import { Box, Divider, Tabs } from '@mui/material';
import { Outlet } from '@tanstack/react-router';
import { ReactNode, useContext } from 'react';
import { PageContext } from 'src/contexts/page-context';

interface Props {
  children: ReactNode;
}

const PageTabs = ({ children }: Props) => {
  const { tabIndex } = useContext(PageContext);

  return (
    <>
      <Box>
        <Tabs
          allowScrollButtonsMobile
          sx={{ mt: 4 }}
          value={tabIndex}
          variant="scrollable">
          {children}
        </Tabs>
        <Divider />
      </Box>
      <Outlet />
    </>
  );
};

export default PageTabs;
